var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$route.name !== 'Login' && _vm.$route.name !== 'Register')?_c('div',{staticClass:"footer"},[_vm._v(" "+_vm._s(_vm.$store.state.phone)+" ")]):_vm._e(),_c('div',{staticClass:"footer"}),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }